import styled from 'styled-components';
import media from '../../../constants/media';
import {asHeading5} from "../../base/typography";

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	padding: 3rem;
	background: #ffffff;
	box-shadow: 0px 14px 34px rgba(0, 0, 0, 0.1);
	border-left: 2px solid ${({ theme }) => theme.colors.primary};
	transition: box-shadow 200ms;

	&:hover {
		box-shadow: 0px 14px 34px rgba(0, 0, 0, 0.15);
	}

	${media.desktopSmall`
		flex-direction: row;
		padding: 4.5rem 6rem;
	`};
`;

export const ContentWrapper = styled.div`
	order: 2;

	${media.desktopSmall`
		order: 1;
	`};
`;

export const BoxHeading = styled.div`
	${asHeading5};
	margin-bottom: 0;
`;

export const BoxText = styled.div`
	margin-top: 2rem;
	margin-bottom: 1.5rem;
`;

export const IconImage = styled.img`
	flex: 0 0 auto;
	width: 4rem;
	margin-bottom: 2rem;
	order: 1;

	${media.desktopSmall`
		width: 7rem;
		margin-bottom: 0;
		margin-left: 7rem;
		order: 2;
	`};
`;

export const ImagePlaceholder = styled.div`
	flex: 0 0 auto;
	width: 4rem;
	order: 1;

	${media.desktopSmall`
		width: 7rem;
		margin-left: 7rem;
		order: 2;
	`};
`;
